document.addEventListener("turbolinks:load", function() {
  if ( $('#recommend-preview-wrapper').length ) {

    // モーダル類の定義
    const editModal = document.querySelector("#recommend-preview-edit-modal");
    const loadingModal = document.querySelector("#loading-modal");
    let loadingText = $("#loading-text");
    const qrCodeModal = document.querySelector("#qr-modal");

    // HTMLエディタの初期化
    let editor = ace.edit('recommend-preview-editor');
    editor.setTheme('ace/theme/monokai');
    editor.session.setMode('ace/mode/html');
    editor.setOptions({
      maxLines: 30,
      minLines: 30
    });


    /**
     * プレビュー作成
     */
    function createPreview(caller) {
      caller.css('pointer-events', 'none');
      let baseUrl = $('#base-url').val();
      if (baseUrl.trim() === '') {
        alert('URLを入力してください');
        caller.css('pointer-events', 'auto');
        return;
      }

      setTimeout(function() { loadingModal.showModal(); }, 1);

      $.ajax({
        url: '/recommend_preview/create_preview',
        type: 'POST',
        data: {
          url: baseUrl
        }
      })
      .done(function(data) {
        if (data['ret'] === 0) {
          alert('プレビューを作成しました！');
          location.reload();
        } else if (data['message']) {
          alert(data['message']);

        } else {
          alert('プレビューの作成に失敗しました');

        }
        caller.css('pointer-events', 'auto');
      })
      .fail(function() {
        alert('プレビューの作成に失敗しました');
        caller.css('pointer-events', 'auto');
      })
      .always(function() {
        loadingModal.close();
      })
    }
    $('#create-recommend-preview').on('click', function() {
      createPreview($(this))
    });


    /**
     * プレビュー編集
     * @param caller
     */
    function editPreview(caller) {
      setTimeout(function() { loadingModal.showModal(); }, 1);

      let previewId = caller.data('preview-id');
      $.ajax({
        url: '/recommend_preview/edit_preview',
        type: 'POST',
        data: {
          id: previewId
        }
      })
        .then(function(data) {
          if (data['ret'] === 0) {
            $('#update-preview').data('preview-id', previewId);
            editor.setValue(data['html_content']);
            editModal.showModal();
          } else {
            alert(data['message']);
          }
        })
        .fail(function() {
          alert('プレビューHTMLの取得に失敗しました');
        })
        .always(function() {
          loadingModal.close();
        })
    }
    $('.edit-preview').on('click', function() {
      $(this).css('pointer-events', 'none');
      editPreview( $(this) );
      $(this).css('pointer-events', 'auto');
    });

    // 編集キャンセル
    $('#edit-cancel').on('click', function() {
      editor.setValue('');
      editModal.close();
      loadingModal.close();
    });



    /**
     * プレビューHTML更新
     */
    function updatePreview(caller) {
      let previewId = caller.data('preview-id');
      let htmlContent = editor.getValue();

      setTimeout(function() { loadingModal.showModal(); }, 1);

      $.ajax({
        url: '/recommend_preview/update_preview',
        type: 'POST',
        data: {
          id: previewId,
          html_content: htmlContent
        }
      })
        .then(function(data) {
          if (data['ret'] === 0) {
            alert('プレビューを更新しました');
            location.reload();
          } else {
            alert(data['message']);
          }
        })
        .fail(function() {
          alert('プレビューの更新に失敗しました');
        })
        .always(function() {
          loadingModal.close();
        })
    }
    $('#update-preview').on('click', function() {
      $(this).css('pointer-events', 'none');
      updatePreview( $(this) );
      $(this).css('pointer-events', 'auto');
    });


    /**
     * プレビュー削除
     */
    function deletePreview(caller) {
      let previewId = caller.data('preview-id');
      if (confirm('プレビューを削除しますか？')) {
        setTimeout(function() { loadingModal.showModal(); }, 1);
        $.ajax({
          url: '/recommend_preview/delete_preview',
          type: 'POST',
          data: {
            id: previewId
          }
        })
          .then(function(data) {
            if (data['ret'] === 0) {
              alert('プレビューを削除しました');
              location.reload();
            } else {
              alert(data['message']);
            }
          })
          .fail(function() {
            alert('プレビューの削除に失敗しました');
          })
          .always(function() {
            loadingModal.close();
          })
      }
    }
    $('.delete-preview').on('click', function() {
      $(this).css('pointer-events', 'none');
      deletePreview( $(this) );
      $(this).css('pointer-events', 'auto');
    });


    /**
     * QRコード表示
     */
    function showQrCode(caller) {
      let previewId = caller.data('preview-id');
      setTimeout(function() { loadingModal.showModal(); }, 1);

      $.ajax({
        url: '/recommend_preview/get_qr_code',
        type: 'POST',
        data: {
          id: previewId
        }
      })
        .then(function(data) {
          if (data['ret'] == 0) {
            $('#qr-code').html(data['svg']);
            qrCodeModal.showModal();
          } else {
            alert(data['message']);
          }
        })
        .fail(function() {
          alert('QRコードの表示に失敗しました');
        })
        .always(function() {
          loadingModal.close();
        })
    }
    $('.show-qr-code').on('click', function() {
      $(this).css('pointer-events', 'none');
      showQrCode( $(this) );
      $(this).css('pointer-events', 'auto');
    });

    $('#qr-cancel').on('click', function() {
      $('#qr-code').html('');
      qrCodeModal.close();
    });



    // エスケープキーでモーダルを閉じないようにする
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
      }
    });



  }
});
